// Sentry initialization should be imported first!
import "./instrument";
import * as Sentry from "@sentry/react";
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// Store for captured events (for admin dashboard)
window.sentryEventStore = window.sentryEventStore || [];

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
)